import { put, select, takeLatest, take } from 'redux-saga/effects';
import { hasSavedPlansSelector, hasSeenNewFeaturesSelector } from 'domain/LocalStorage/selectors';
import { setHasSeenNewFeatures } from 'domain/LocalStorage/actions';
import { applicationModeSelector } from 'Application/selectors';
import { KIOSK } from 'Application/constants';
import { showNewFeaturesToast } from 'Application/actions';
import { CHECK_FOR_NEW_FEATURES, OPTIONS_LOADED } from '../constants';

export function* checkForNewFeatures() {
  // Application mode only correctly set after options are loaded
  yield take(OPTIONS_LOADED);
  const applicationMode = yield select(applicationModeSelector);
  if (applicationMode !== KIOSK) {
    const hasSavedPlans = yield select(hasSavedPlansSelector);
    const hasSeenNewFeatures = yield select(hasSeenNewFeaturesSelector);

    if (hasSavedPlans && !hasSeenNewFeatures) {
      yield put(showNewFeaturesToast(true));
    } else if (!hasSavedPlans) {
      yield put(setHasSeenNewFeatures(true));
    }
  }
}

export default function* newFeaturesSaga() {
  yield takeLatest(CHECK_FOR_NEW_FEATURES, checkForNewFeatures);
}
